export default __webpack_public_path__ + "static/media/close.e979c39e.svg";